import React from 'react'
import Job from './Job.js'

export default function JobRequisition() {
  return (
    <div class ="jobRequisition">
        <Job/>
    </div>
  )
}
